module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+R3JvdXAgNDwvdGl0bGU+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjMiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cGF0aCBkPSJNMi40NiAxLjY0bDI0LjkxNyAyNC45MTVNMjcuMzc3IDEuNjRMMi40NiAyNi41NTQiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = 41
// module chunks = 0